module.exports = __webpack_public_path__ + "media/images/logo-4541ebba0297dfd9cb2e919738fc13cc.png";